document.addEventListener('DOMContentLoaded', function() {
  // Cursor
  const cursor = document.getElementById('cursor');
  const ring = document.getElementById('cursor-ring');
  if (cursor && ring) {
    document.addEventListener('mousemove', e => {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top  = e.clientY + 'px';
      setTimeout(() => { ring.style.left = e.clientX + 'px'; ring.style.top = e.clientY + 'px'; }, 60);
    });
  }

  // Sticky nav
  window.addEventListener('scroll', () => {
    document.getElementById('main-nav')?.classList.toggle('scrolled', window.scrollY > 60);
  });

  // Scroll reveal
  const revealObs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

  // Cart
  refreshCart();
});

// Mobile menu
function toggleMobileMenu() {
  const m = document.getElementById('mobile-menu');
  const h = document.getElementById('hamburger');
  m.classList.toggle('open');
  h.classList.toggle('open');
  document.body.style.overflow = m.classList.contains('open') ? 'hidden' : '';
}

// Cart drawer
function openCart()  { document.getElementById('cart-drawer').classList.add('open');    document.getElementById('cart-overlay').classList.add('open'); }
function closeCart() { document.getElementById('cart-drawer').classList.remove('open'); document.getElementById('cart-overlay').classList.remove('open'); }

async function refreshCart() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
    const body   = document.getElementById('cart-body');
    const footer = document.getElementById('cart-footer');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><span>Your bag is empty</span><small>Add a shirt to get started</small></div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    if (footer) {
      footer.style.display = 'block';
      document.getElementById('cart-total').textContent =
        Shopify.formatMoney ? Shopify.formatMoney(cart.total_price) :
        '\u20b9' + (cart.total_price / 100).toLocaleString('en-IN');
    }
    body.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <div class="cart-item-img">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy"/>` : ''}
        </div>
        <div class="cart-item-info">
          <div class="cart-item-name">${item.product_title}</div>
          <div class="cart-item-meta">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="cart-item-actions">
            <button class="qty-btn" onclick="updateCart(${item.variant_id},${item.quantity - 1})">−</button>
            <span class="qty-num">${item.quantity}</span>
            <button class="qty-btn" onclick="updateCart(${item.variant_id},${item.quantity + 1})">+</button>
          </div>
        </div>
        <div class="cart-item-price">\u20b9${(item.line_price / 100).toLocaleString('en-IN')}</div>
      </div>`).join('');
  } catch(e) { console.error('Cart error:', e); }
}

async function updateCart(variantId, qty) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  });
  await refreshCart();
}

// Product grid view toggle
let currentView = 'grid';
function setView(view) {
  currentView = view;
  const grid = document.getElementById('product-grid');
  const bg = document.getElementById('btn-grid');
  const bl = document.getElementById('btn-list');
  if (!grid) return;
  if (view === 'list') { grid.classList.add('list-view'); bl?.classList.add('active'); bg?.classList.remove('active'); }
  else                 { grid.classList.remove('list-view'); bg?.classList.add('active'); bl?.classList.remove('active'); }
  if (window.NR?.products) renderGrid();
}

// Client-side filter (homepage / collection page)
let sizeFilter = 'all', typeFilter = 'all';
function setSize(val, btn) {
  sizeFilter = val;
  document.querySelectorAll('.size-pill').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  updateFilters(); renderGrid();
}
function setType(val, btn) {
  typeFilter = val;
  document.querySelectorAll('.type-pill').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  updateFilters(); renderGrid();
}
function updateFilters() {
  const el = document.getElementById('active-filters');
  if (!el) return;
  if (sizeFilter === 'all' && typeFilter === 'all') { el.innerHTML = ''; return; }
  let h = '';
  if (sizeFilter !== 'all') h += `<span class="active-tag">${sizeFilter}<button onclick="document.querySelectorAll('.size-pill')[0].click()">&times;</button></span>`;
  if (typeFilter !== 'all') h += `<span class="active-tag">${typeFilter}<button onclick="document.querySelectorAll('.type-pill')[0].click()">&times;</button></span>`;
  h += `<button class="clear-all" onclick="document.querySelectorAll('.size-pill')[0].click();document.querySelectorAll('.type-pill')[0].click();">Clear all</button>`;
  el.innerHTML = h;
}
function renderGrid() {
  const products = window.NR?.products;
  if (!products) return;
  const grid = document.getElementById('product-grid');
  if (!grid) return;
  const filtered = products.filter(p => {
    const typeOk = typeFilter === 'all' || (p.type || '').toLowerCase() === typeFilter.toLowerCase() || p.tags.some(t => t.toLowerCase() === typeFilter.toLowerCase());
    const sizeOk = sizeFilter === 'all' || p.sizes.includes(sizeFilter);
    return typeOk && sizeOk;
  });
  const countEl = document.getElementById('results-count');
  if (countEl) countEl.textContent = filtered.length + ' shirt' + (filtered.length !== 1 ? 's' : '');
  if (!filtered.length) {
    grid.innerHTML = '<div class="no-results"><div class="no-results-title">No shirts found</div><div class="no-results-sub">Try a different size or type</div></div>';
    return;
  }
  const isList = currentView === 'list';
  grid.innerHTML = filtered.map(p => {
    const imgHtml = p.image ? `<img src="${p.image}" alt="${p.name}" loading="lazy"/>` : '<div class="product-img-placeholder"></div>';
    const listBtn = isList ? `<button class="list-add-btn" onclick="event.stopPropagation();quickAdd(${p.id},this)">Add to bag</button>` : '';
    return `<div class="product-card reveal" onclick="window.location='${p.url}'" data-type="${(p.type||'').toLowerCase()}">
      <div class="product-img-wrap">${imgHtml}<div class="product-type-badge">${p.type}</div></div>
      <div class="product-info">
        <div class="product-info-inner">
          <div class="product-meta"><span class="product-type-label">${p.type}</span><span class="product-price">&#8377;${p.price}</span></div>
          <div class="product-name">${p.name}</div>
          <div class="size-mini">${p.sizes.map(sz => `<span class="size-mini-tag" onclick="event.stopPropagation();this.closest('.size-mini').querySelectorAll('.size-mini-tag').forEach(t=>t.classList.remove('selected'));this.classList.add('selected')">${sz}</span>`).join('')}</div>
          <div class="view-details-hint">View details <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5h6M5 2l3 3-3 3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
        </div>${listBtn}
      </div>
    </div>`;
  }).join('');
  const obs = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }), { threshold: 0.1 });
  grid.querySelectorAll('.product-card.reveal').forEach(el => obs.observe(el));
}

async function quickAdd(productId, btn) {
  const products = window.NR?.products;
  if (!products) return;
  const p = products.find(x => x.id === productId);
  if (!p) return;
  btn.textContent = 'Adding...';
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: productId, quantity: 1 })
    });
    btn.textContent = 'Added ✓';
    await refreshCart();
    setTimeout(() => btn.textContent = 'Add to bag', 1400);
  } catch(e) {
    btn.textContent = 'Error';
    setTimeout(() => btn.textContent = 'Add to bag', 1400);
  }
}